import type { LucideProps } from 'lucide-react'

export function ConnectIcon({ className, ...props }: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <path d="M12 22v-5" />
            <path d="M9 8V2" />
            <path d="M15 8V2" />
            <path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z" />
        </svg>
    )
}

export function ConnectIconGradient({ className, ...props }: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            {...props}
        >
            <defs>
                <linearGradient id="connect-icon-gradient" x1="12" y1="2" x2="12" y2="22" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#2563EB" /> {/* blue-600 */}
                    <stop offset="1" stopColor="#9333EA" /> {/* purple-600 */}
                </linearGradient>
            </defs>
            <path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z" fill="url(#connect-icon-gradient)" stroke="none" />
            <path d="M12 22v-5" stroke="url(#connect-icon-gradient)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 8V2" stroke="url(#connect-icon-gradient)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 8V2" stroke="url(#connect-icon-gradient)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
